/* Registrations.js */

'use strict';

module.exports = {
    fromNamespace:"FSM.Appendages.sRoute.from.",
    toNamespace:"FSM.Appendages.sRoute.to.",
    Eula:"FSM.Appendages.sRoute.from.LoginCenter.Eula",
    EulaFromUndef: "FSM.Appendages.sRoute.from.undefined.Eula",
    EulaToAny: "FSM.Appendages.sRoute.to.any.Eula",
    Banner: "FSM.Appendages.sRoute.from.LoginCenter.Banner",
    BannerFromEula: "FSM.Appendages.sRoute.from.Eula.Banner",
    BannerToAny: "FSM.Appendages.sRoute.to.any.Banner",
    Startup:"FSM.Appendages.sRoute.from.undefined.Startup",
    ReconnectStartup:"FSM.Appendages.sRoute.from.FailComms.Startup",
    ShowHomeBar:"FSM.Appendages.sRoute.from.LoginCenter.ShowHomeBar",
    HideHomeBar:"FSM.Appendages.sRoute.to.any.ShowHomeBar",
    HomeBarFromUndef:"FSM.Appendages.sRoute.from.undefined.ShowHomeBar"
};
